import React from "react";

const PROGRAM_PRICING = {
  undergrad: {
    oneTime: "1200 €",
    semester: "1400 €",
    installments: "1500 €",
  },
  master: {
    oneTime: "1500 €",
    semester: "1700 €",
    installments: "1800 €",
  },
};

function ProgramPricingInfo({ level = "undergrad", t }) {
  const pricing = PROGRAM_PRICING[level] || PROGRAM_PRICING.undergrad;

  const paymentOptions = [
    {
      key: "oneTime",
      label: t("programi.jednokratnoDoOktobra"),
      value: pricing.oneTime,
      featured: true,
    },
    {
      key: "semester",
      label: t("programi.semestralno"),
      value: pricing.semester,
      featured: false,
    },
    {
      key: "installments",
      label: t("programi.narate"),
      value: pricing.installments,
      featured: false,
    },
  ];

  return (
    <div className="program-payment-box" aria-label={t("programi.paymentOptions")}>
      {paymentOptions.map((option) => (
        <div
          className={`program-payment-option${option.featured ? " is-featured" : ""}`}
          key={option.key}
        >
          <span>{option.label}</span>
          <strong>{option.value}</strong>
        </div>
      ))}
    </div>
  );
}

export default ProgramPricingInfo;
